var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedWidget)?_c('div',{staticClass:"chat-widget-container"},[_c(_vm.selectedWidget,{ref:"widget",tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }